<template>
    <div class="match-details__stats-container">
        <div class="match-detail__stats-wrapper">
            
            <div class="analysis-title">
                {{ $t('LEAGUE_STANDING') }}
            </div>

            <template  v-if="(results?.homeTeam.standings.length > 0 || results?.awayTeam.standings.length > 0)">


              <!-- <template v-if="(results?.homeTeam.standings.length > 0 || results?.awayTeam.standings.length > 0)"> -->
                  <div class="nav-pill__wrapper mb-main" v-if="isMobile">
                      <div
                          class="nav-pill btn-aspn-default"
                          :class="{ selected: o.selected }"
                          v-for="(o, index) in tabs"
                          :key="index"
                          @click="selectTabs(o)"
                      >
                          {{ o.name }}
                      </div>
                  </div>
                  
                  <div class="team-box-list" v-if="isMobile">
                    <div class="team-box" v-for="(o, teamKey) in results" :key="teamKey"> <!-- result -->
                      
                        <div class="team-box-team-header">
                            <div class="team-box-icon">
                                <div class="team-box-country">
                                    <Icon :logoUrl="matchDetailScore[teamKey === 'homeTeam' ? 'homeLogo' : 'awayLogo']"
                                        hasClass="match-detail-standing-team-icon">
                                    </Icon>
                                </div>
                            </div>
                            <div>
                                <div class="team-box-team">{{ o.name }}</div>
                            </div>
                        </div>
                        <div class="team-box-container" v-if="o.standings.length > 0">
                            <div class="team-box-line team-box-header">
                                <div class="team-box-item box-standingType">{{ $t('TOTAL') }}</div>
                                <div class="team-box-item">MP</div>
                                <div class="team-box-item">W</div>
                                <div class="team-box-item">D</div>
                                <div class="team-box-item">L</div>
                                <div class="team-box-item">GS</div>
                                <div class="team-box-item">GA</div>
                                <div class="team-box-item">GD</div>
                                <div class="team-box-item">Pts</div>
                                <div class="team-box-item">Pos</div>
                                <div class="team-box-item">{{$t('WIN')}}%</div>
                            </div>
                            <template v-for="(a,i2) in o.standings" 
                                :key="i2">
                                <div class="team-box-line" 
                                    :class="`line-${i2}`"
                                    v-if="displayIndex.includes(i2)">
                                    <div  v-for="(b,i3) in a" class="team-box-item" :class="`box-${i3}`">
                                        <template v-if="i3 === 'standingType' && i2 < 4">
                                            {{ $t('FT') }}
                                        </template>
                                        <template v-else-if="i3 === 'standingType' && i2 >= 4">
                                            {{ $t('HT') }}
                                        </template>
                                        <template v-else>
                                            {{ b }}
                                        </template>
                                        <template v-if="i3 === 'winRate'">
                                            % 
                                        </template>
                                    </div>
                                    
                                </div>
                            </template>
                        </div>
                        
                        <NoData v-else />
                    </div>
                  </div>
  
                  <div class="team-box-list" v-else>
                    <div class="team-box" v-for="(o, teamKey) in results" :key="teamKey"
                      :class="teamKey"> <!-- result -->
                        
                        <div class="team-box-container" v-if="o.standings.length > 0">
                          <div v-for="c in ['FT','HT']" :class="c">
                            <div class="team-box-line team-box-header">
                                <div class="team-box-item box-standingType">{{ c }}</div>
                                <div class="team-box-item">MP</div>
                                <div class="team-box-item">W</div>
                                <div class="team-box-item">D</div>
                                <div class="team-box-item">L</div>
                                <div class="team-box-item">GS</div>
                                <div class="team-box-item">GA</div>
                                <div class="team-box-item">GD</div>
                                <div class="team-box-item">Pts</div>
                                <div class="team-box-item">Pos</div>
                                <div class="team-box-item">{{$t('WIN')}}%</div>
                            </div>
                            <template v-for="(a,i2) in o.standings" 
                                :key="i2">
                                <div class="team-box-line" 
                                    v-if="(c === 'FT' && i2 < 4) || (c === 'HT' && i2 >= 4)"
                                    :class="`line-${i2}`">
                                    <div  v-for="(b,i3) in a" class="team-box-item" :class="`box-${i3}`">
                                         <template v-if="i3 === 'standingType' && i2 < 4">
                                            {{ $t(positionLabel[i2]) }}
                                        </template>
                                        <template v-else-if="i3 === 'standingType' && i2 >= 4">
                                            {{ $t(positionLabel[i2 - 4]) }}
                                        </template>
                                        <template v-else>
                                            {{ b === null ? '-' : b }}
                                        </template>
                                        <template v-if="i3 === 'winRate'">
                                            % 
                                        </template>
                                    </div>
                                    
                                </div>
                            </template>
                          </div>
                        </div>
                        <NoData v-else />
                    </div>
                  </div>
              <!-- </template> -->
              <!-- <template v-else>
                  <NoData />
              </template> -->
            </template>

            

            <NoData v-else />
        </div>
    </div>

</template>


<script>
import { mapActions, mapGetters } from "vuex";
import GeneralContentSkeleton from '@/components/skeletonLoading/GeneralContentSkeleton.vue';
export default {
  components: {
    GeneralContentSkeleton,
  },
  data() {
    return {
        displayIndex: [0,4],
        tabs: [
            {
                name: "Total",
                id: "",
                index: [0,4],
                selected: true,
            },
            {
                name: "Home",
                id: "1",
                index: [1,5],
                selected: false,
            },
            {
                name: "Away",
                id: "2",
                index: [2,6],
                selected: false,
            },
            {
                name: "Last 6",
                id: "3",
                index: [3,7],
                selected: false,
            },
        ],
      positionLabel: ["TOTAL", "HOME", "AWAY", "LAST_6",],
      headerFirstHalfLabel: [
        "SHORT_FULL_TIME",
        "SHORT_MATCH",
        "SHORT_WIN",
        "SHORT_DRAW",
        "SHORT_LOSE",
        "SHORT_GOALS",
        "SHORT_CEDE",
        "SHORT_MARGIN",
        "SHORT_POINTS",
        "SHORT_RANKING",
        "SHORT_WIN_RATE",
      ],
      headersecondHalfLabel: [
        "SHORT_HALF_TIME",
        "SHORT_MATCH",
        "SHORT_WIN",
        "SHORT_DRAW",
        "SHORT_LOSE",
        "SHORT_GOALS",
        "SHORT_CEDE",
        "SHORT_MARGIN",
        "SHORT_POINTS",
        "SHORT_RANKING",
        "SHORT_WIN_RATE",
      ],
      teamSelected: "homeTeam",
      // isLoading: false,
      isNodata: false,
      results: null,
      mobileResults: null,
      matchId: "",
      isSkeletonLoading: {
        leagueStanding: false,
      }
    };
  },
  props: {
    matchDetailScore: Object
  },
  created() {
    this.matchId = this.$route.params.matchId;
    // this.matchId = 2175176;
  },
  mounted() {
    this.getLeagueStandingData();
  },
  watch: {
    teamSelected(newVal) {
      this.mobileResults = this.results[newVal];
    },
    currentLocale: {
      deep: true,
      handler(newVal, oldVal) {
        this.getLeagueStandingData();
      },
    },
    manualRefreshMatchDetail: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.getLeagueStandingData();
        }
      },
    },
  },

  computed: {
    ...mapGetters([
      "isMobile", 
      "currentLocale",
      "manualRefreshMatchDetail",
    ]),
  },
  methods: {
    ...mapActions(["getLeagueStanding"]),

    async getLeagueStandingData() {
      // this.isLoading = true;
      if (this.manualRefreshMatchDetail) {
        this.isSkeletonLoading.leagueStanding = true;
      }
      const result = await this.getLeagueStanding({ matchId: this.matchId });
      if (this.manualRefreshMatchDetail) {
        this.isSkeletonLoading.leagueStanding = false;
        this.verifyIfAllAPICallsDone();
      }
      // this.isLoading = false;
      // sample
      if(this.matchId === '2596909') {

        result.result = {
          "homeTeam": {
              "teamId": 123,
              "name": "Real Valladolid",
              "standings": [
                  {
                      "standingType": "total",
                      "totalCount": 29,
                      "winCount": 4,
                      "drawCount": 4,
                      "loseCount": 21,
                      "getScore": 19,
                      "loseScore": 65,
                      "goalDifference": -46,
                      "integral": 16,
                      "ranking": 20,
                      "winRate": "13.8"
                  },
                  {
                      "standingType": "home",
                      "totalCount": 14,
                      "winCount": 3,
                      "drawCount": 4,
                      "loseCount": 7,
                      "getScore": 8,
                      "loseScore": 21,
                      "goalDifference": -13,
                      "integral": 13,
                      "ranking": 20,
                      "winRate": "21.4"
                  },
                  {
                      "standingType": "away",
                      "totalCount": 15,
                      "winCount": 1,
                      "drawCount": 0,
                      "loseCount": 14,
                      "getScore": 11,
                      "loseScore": 44,
                      "goalDifference": -33,
                      "integral": 3,
                      "ranking": 20,
                      "winRate": "6.7"
                  },
                  {
                      "standingType": "last6",
                      "totalCount": 6,
                      "winCount": 0,
                      "drawCount": 1,
                      "loseCount": 5,
                      "getScore": 4,
                      "loseScore": 17,
                      "goalDifference": -13,
                      "integral": 1,
                      "ranking": null,
                      "winRate": "0.0"
                  },
                  {
                      "standingType": "half",
                      "totalCount": 29,
                      "winCount": 2,
                      "drawCount": 13,
                      "loseCount": 14,
                      "getScore": 5,
                      "loseScore": 27,
                      "goalDifference": -22,
                      "integral": 19,
                      "ranking": 20,
                      "winRate": "6.9"
                  },
                  {
                      "standingType": "homeHalf",
                      "totalCount": 14,
                      "winCount": 2,
                      "drawCount": 7,
                      "loseCount": 5,
                      "getScore": 2,
                      "loseScore": 8,
                      "goalDifference": -6,
                      "integral": 13,
                      "ranking": 20,
                      "winRate": "14.3"
                  },
                  {
                      "standingType": "awayHalf",
                      "totalCount": 15,
                      "winCount": 0,
                      "drawCount": 6,
                      "loseCount": 9,
                      "getScore": 3,
                      "loseScore": 19,
                      "goalDifference": -16,
                      "integral": 6,
                      "ranking": 20,
                      "winRate": "0.0"
                  },
                  {
                      "standingType": "halfLast6",
                      "totalCount": 6,
                      "winCount": 0,
                      "drawCount": 2,
                      "loseCount": 4,
                      "getScore": 1,
                      "loseScore": 9,
                      "goalDifference": -8,
                      "integral": 2,
                      "ranking": null,
                      "winRate": "0.0"
                  }
              ]
          },
          "awayTeam": {
              "teamId": 98,
              "name": "Getafe",
              "standings": [
                  {
                      "standingType": "total",
                      "totalCount": 29,
                      "winCount": 9,
                      "drawCount": 9,
                      "loseCount": 11,
                      "getScore": 26,
                      "loseScore": 25,
                      "goalDifference": 1,
                      "integral": 36,
                      "ranking": 11,
                      "winRate": "31.0"
                  },
                  {
                      "standingType": "home",
                      "totalCount": 15,
                      "winCount": 4,
                      "drawCount": 7,
                      "loseCount": 4,
                      "getScore": 13,
                      "loseScore": 11,
                      "goalDifference": 2,
                      "integral": 19,
                      "ranking": 15,
                      "winRate": "26.7"
                  },
                  {
                      "standingType": "away",
                      "totalCount": 14,
                      "winCount": 5,
                      "drawCount": 2,
                      "loseCount": 7,
                      "getScore": 13,
                      "loseScore": 14,
                      "goalDifference": -1,
                      "integral": 17,
                      "ranking": 8,
                      "winRate": "35.7"
                  },
                  {
                      "standingType": "last6",
                      "totalCount": 6,
                      "winCount": 3,
                      "drawCount": 0,
                      "loseCount": 3,
                      "getScore": 8,
                      "loseScore": 8,
                      "goalDifference": 0,
                      "integral": 9,
                      "ranking": null,
                      "winRate": "50.0"
                  },
                  {
                      "standingType": "half",
                      "totalCount": 29,
                      "winCount": 5,
                      "drawCount": 13,
                      "loseCount": 11,
                      "getScore": 7,
                      "loseScore": 14,
                      "goalDifference": -7,
                      "integral": 28,
                      "ranking": 17,
                      "winRate": "17.2"
                  },
                  {
                      "standingType": "homeHalf",
                      "totalCount": 15,
                      "winCount": 3,
                      "drawCount": 8,
                      "loseCount": 4,
                      "getScore": 5,
                      "loseScore": 6,
                      "goalDifference": -1,
                      "integral": 17,
                      "ranking": 17,
                      "winRate": "20.0"
                  },
                  {
                      "standingType": "awayHalf",
                      "totalCount": 14,
                      "winCount": 2,
                      "drawCount": 5,
                      "loseCount": 7,
                      "getScore": 2,
                      "loseScore": 8,
                      "goalDifference": -6,
                      "integral": 11,
                      "ranking": 16,
                      "winRate": "14.3"
                  },
                  {
                      "standingType": "halfLast6",
                      "totalCount": 6,
                      "winCount": 1,
                      "drawCount": 2,
                      "loseCount": 3,
                      "getScore": 2,
                      "loseScore": 4,
                      "goalDifference": -2,
                      "integral": 5,
                      "ranking": null,
                      "winRate": "16.7"
                  }
              ]
          }
        }
      }
      this.dataValidation(result.result);
    },
    dataValidation(data) {
      if (!data.homeTeam && !data.awayTeam) {
        this.isNoData = true;
      } else {
        this.isNoData = false;
        this.results = data;
        this.mobileResults = this.results[this.teamSelected];
      }
    },
    splitHalf(arr, arrPos) {
      const firstHalf = arr.slice(0, Math.ceil(arr.length / 2));
      const secondHalf = arr.slice(-Math.ceil(arr.length / 2));
      if (arrPos === "first") {
        return firstHalf;
      } else if (arrPos === "second") {
        return secondHalf;
      }
    },
    selectTeam(id) {
      this.teamSelected = id;
    },
    verifyIfAllAPICallsDone() {
      if (!this.isSkeletonLoading.leagueStanding) {
        this.$emit("apiCallsDone");
      }
    },
    selectTabs(o) {
        this.tabs.forEach(x => {
            x.selected = false;
        })
        o.selected = true
        this.displayIndex = o.index
    }
  },
};
</script>

<style scoped>

.analysis-title {
    font-size: 24px;
    font-family: var(--weight-600);
    letter-spacing: -0.48px;
    margin-bottom: 24px;
    text-align: center;
    color: var(--color-text-default-default);
}
.analysis-hint-text {
    font-size: 16px;
    color: var(--color-text-default-secondary);
    text-align: center;
    margin-bottom: 16px;
}
.team-box-list {
  display: flex;
  align-items: stretch;
  gap: 16px;
}
.team-box {
  flex: 1;
  margin-bottom: 24px;
  border: 1px solid var(--color-border-default-default);
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
}
.team-box.homeTeam:after {
  position: absolute;
  display: block;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  height: 8px;
  background-color: var(--success-500);
}
.team-box.awayTeam:after {
  position: absolute;
  display: block;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  height: 8px;
  background-color: var(--secondary-500);
}

.team-box-line {
    display: grid;
    grid-template-columns: calc(100% - 273px) 25px 25px 25px 25px 25px 25px 25px 25px 25px 48px;
    text-align: center;
    width: 100%;
    font-size: 13px;
    font-family: var(--weight-400);
    height: 26px;
}
.team-box-item {
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: .52px;
    color: var(--color-text-default-default);
}
.box-standingType {
    justify-content: left;
    font-family: var(--weight-600);
}
.box-winRate {

    font-family: var(--weight-600);
}
.team-box-header {
    font-size: 13px;
    font-family: var(--weight-600);
    color: var(--color-text-default-secondary);
}
.match-detail-standing-team-icon {
    width: 40px;
    height: 40px;
    padding: 2.03px;
    box-sizing: border-box;
}
.team-box-team-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 14px;
    letter-spacing: .64px;
}
.team-box-container .HT .team-box-header {
  margin-top: 14px;
}
.team-box-header .team-box-item {
  color: var(--color-text-default-secondary);
}
.team-box-team {
    color: var(--color-text-default-default);
    font-size: 16px;
    font-family: var(--weight-600);
}

.match-details__stats-container {
  border-top: 1px dashed var(--color-border-default-default);
  padding-top: 32px;
  margin-top: 16px;
}
@media(max-width: 768px) {  /* for test */
.match-details__stats-container {
  background-color: var(--color-background-default-secondary);
  border-radius: 8px;
  /* margin-top: 16px; */
  padding: 8px;
  margin-bottom: 16px;
  margin-top: 0;
  border-top: 0;
}
.nav-pill__wrapper {
    margin-bottom: 16px;
    padding: 8px 0;
    justify-content: space-between;
}
.nav-pill {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid var(--color-border-default-default);
    border-radius: 17px;
}
.team-list {
  display: block;
}
.team-box {
    margin-bottom: 0;
    border: 0;
}
.team-box-list {
  display: block;
}
}

@media(max-width: 375px) {
.team-box {
  padding: 16px 8px;
}
  
}
</style>